import { Injectable } from '@angular/core';
import { AppConfig } from '../shared/models/appconfig.model';
import { WindowRefService } from './window-ref.service';

@Injectable(
  { providedIn: 'root' }
)
export class ConfigService {
  public config: AppConfig;

  constructor(windowRef: WindowRefService) {
    this.config = windowRef.nativeWindow?.appconfig || {} as AppConfig;

    if (!this.config) {
      throw new Error('App configuration not loaded.');
    }
  }
}
